import { Accordion, Span, Stack, Text, useSlotRecipe } from '@chakra-ui/react';

import { MarkdownRenderer } from '@app/components/atoms/markdown-renderer';
import { MimeTypes } from '@app/enums';

import { ListingFaqProps } from './listing-faq.props';
import { generateListingFaqSchema } from './listing-faq.utils';

export const ListingFaq = ({ faqData }: ListingFaqProps) => {
    const recipe = useSlotRecipe({ key: 'faq' });
    const styles = recipe({});
    const faqList = faqData.items;

    if (!faqList || !faqList.length) {
        return null;
    }

    const schemaObj = generateListingFaqSchema(faqList);

    return (
        <>
            {schemaObj ? (
                <script
                    type={MimeTypes.jsonld}
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaObj) }}
                />
            ) : null}
            <Stack css={styles.root} data-testid="faq-wrapper">
                <Text as="h2" css={styles.title} data-testid="faq-header">
                    {faqData.header}
                </Text>
                <Accordion.Root multiple variant="outline">
                    {faqList.map((item, index) => (
                        <Accordion.Item key={index} value={item.question} data-testid="faq-item">
                            <Accordion.ItemTrigger
                                css={styles.itemTrigger}
                                data-testid="faq-question"
                            >
                                <Span flex="1">{item.question}</Span>
                                <Accordion.ItemIndicator />
                            </Accordion.ItemTrigger>
                            <Accordion.ItemContent
                                css={styles.itemContent}
                                data-testid="faq-answer"
                            >
                                <Accordion.ItemBody>
                                    <MarkdownRenderer content={item.answer} />
                                </Accordion.ItemBody>
                            </Accordion.ItemContent>
                        </Accordion.Item>
                    ))}
                </Accordion.Root>
            </Stack>
        </>
    );
};
